import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefOBGyExaminationPerVaginalExaminationDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationPerVaginalExamination/GetDetail?` + params, null);

export const GetRefOBGyExaminationPerVaginalExaminationList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationPerVaginalExamination/GetList?` + params, null);

export const CreateRefOBGyExaminationPerVaginalExamination = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationPerVaginalExamination/Create`, data);

export const UpdateRefOBGyExaminationPerVaginalExamination = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationPerVaginalExamination/Update`, data);

export const DeleteRefOBGyExaminationPerVaginalExamination = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationPerVaginalExamination/Delete`, data);